import React, { useState, useRef, useEffect } from 'react';
import axios from 'axios';
import { Editor } from '@toast-ui/react-editor';
import '@toast-ui/editor/dist/toastui-editor.css';
import colorSyntax from '@toast-ui/editor-plugin-color-syntax';
import 'tui-color-picker/dist/tui-color-picker.css';
import { useNavigate, useLocation } from 'react-router-dom';

const InquiryWrite = () => {
  const [title, setTitle] = useState(''); // 제목
  const [content, setContent] = useState(''); // 내용
  const [writer, setWriter] = useState(''); //작성자
  const [tel, setTel] = useState(''); //연락처
  const [selectedFiles, setSelectedFiles] = useState([]); // 파일 첨부
  const [fileUrls, setFileUrls] = useState([]); // 파일 URL
  const [secretChk, setSecretChk] = useState(false); // 비밀글 체크
  const [password, setPassword] = useState(''); // 비밀번호
  const [select, setSelect] = useState(0); // 상단 네비 드롭다운
  const editorRef = useRef(null);

  const navigate = useNavigate();
  const location = useLocation();
  const cate = 'inquiry';

  // 상단 네비 드롭다운
  const handleSelect = (num) => {
    if (select === num) {
      setSelect(0);
    } else {
      setSelect(num);
    }
  };

  const moveBoard = (cate) => {
    navigate(`/board/${cate}`, { state: { cate: cate } });
  };

  const movePage = (path) => {
    navigate(path);
  };

  const isActive = (path) => {
    return location.pathname === path ? 'active' : '';
  };

  // 파일 첨부 삭제
  const handleFileDelete = (index) => {
    const updatedFiles = [...selectedFiles];
    updatedFiles.splice(index, 1);
    setSelectedFiles(updatedFiles);

    const updatedUrls = [...fileUrls];
    updatedUrls.splice(index, 1);
    setFileUrls(updatedUrls);
  };

  // Editor 파일 업로드 관련 함수
  const onUploadImage = async (blob, callback) => {
    try {
      const formData = new FormData();
      formData.append('image', blob);

      const response = await axios.post('https://ciuc.or.kr:8443/api/post/upload', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      const imageUrl = response.data.imageUrl;
      console.log('Uploaded image URL:', imageUrl); // 이미지 URL
      callback(imageUrl, 'alt text');
    } catch (error) {
      console.error('이미지 업로드 중 오류 발생', error);
    }
  };

  // 내용 체크
  const handleContent = () => {
    const editorInstance = editorRef.current.getInstance();
    const htmlContent = editorInstance.getHTML();
    setContent(htmlContent);
  };

  const handleFileSelect = (e) => {
    const files = Array.from(e.target.files);
    const totalFiles = selectedFiles.length + files.length;

    if (totalFiles > 5) {
      alert('첨부파일은 최대 5개까지입니다.');
      return;
    }

    const urls = files.map((file) => URL.createObjectURL(file));

    setSelectedFiles([...selectedFiles, ...files]);
    setFileUrls([...fileUrls, ...urls]);
  };

  // 글 등록 핸들러
  const handleSubmit = async () => {
    if (title === '') {
      alert('제목을 입력해주세요.');
      return;
    } else if (content === '') {
      alert('내용을 입력해주세요.');
      return;
    } else if (writer === '') {
      alert('이름을 입력해주세요.');
      return;
    } else if (tel === '') {
      alert('연락처를 입력해주세요.');
      return;
    } else if (secretChk && password === '') {
      alert('비밀번호를 입력해주세요.');
      return;
    }

    // 첨부 파일
    const formData = new FormData();
    formData.append('title', title);
    formData.append('content', content);
    formData.append('writer', writer);
    formData.append('tel', tel);
    formData.append('password', password);
    formData.append('cate', cate);

    selectedFiles.forEach((file) => {
      // 파일 이름 URL 인코딩
      const encodedFileName = encodeURIComponent(file.name);
      formData.append('files', file, encodedFileName);
    });

    try {
      const response = await axios.post('https://ciuc.or.kr:8443/api/post/inquiry_write', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      console.log(response.data);
      alert(`글 등록이 완료되었습니다.`);

      setTitle('');
      setContent('');
      setSelectedFiles([]);

      if (cate === 'archive') {
        navigate('/archive');
      } else {
        console.log('catecatecate', cate);
        navigate(`/board/${cate}`, { state: { cate: cate } });
      }
    } catch (error) {
      console.error(error);
    }
  };

  const handleFileClick = () => {
    document.getElementById('file_input').click();
  };

  useEffect(() => {
    if (!secretChk) {
      setPassword('');
    }
  }, [secretChk]);

  return (
    <div className="sub_wrap board">
      <div className="sub_back">
        {/* 상단 배너 */}
        <div className="sub_banner_area business-field">
          <div className="sub_banner_back">
            <div className="navi_text">
              <div className="home_icon_sub"></div>
              {'> '}기업연구동{' > '}입주문의
            </div>
            <div className="banner_main_text">입주문의</div>
          </div>
        </div>

        {/* 상단 네비게이션 */}
        <div className="navi_area">
          <div className="navi_back">
            <div className="navi_box" onClick={() => handleSelect(1)}>
              <div className="navi_main_text">기업연구동</div>
              <div className="navi_arrow"></div>
              <div className={`navi_select_box ${select === 1 && 'active'}`}>
                <div className="select_row" onClick={() => moveBoard('notice')}>
                  알림 및 소식
                </div>
                <div className="select_row" onClick={() => movePage('/fusionSupportProgram')}>
                  사업분야
                </div>
                <div className="select_row" onClick={() => movePage('/inquiryinfo')}>
                  기업연구동
                </div>
                <div className="select_row" onClick={() => movePage('/meetingroom')}>
                  보유시설
                </div>
                <div className="select_row" onClick={() => movePage('/vision')}>
                  융합원소개
                </div>
              </div>
            </div>
            <div className="navi_box" onClick={() => handleSelect(2)}>
              <div className="navi_main_text">입주문의</div>
              <div className="navi_arrow"></div>
              <div className={`navi_select_box ${select === 2 && 'active'}`}>
                <div className="select_row" onClick={() => movePage('/inquiryinfo')}>
                  입주안내
                </div>
                <div className="select_row" onClick={() => movePage('/floor')}>
                  층별안내
                </div>
                <div className="select_row" onClick={() => movePage('/company')}>
                  입주기업현황
                </div>
                <div className="select_row" onClick={() => moveBoard('inquiry')}>
                  입주문의
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* 메인 영역 */}
        <div className="sub_main_area board">
          {/* 왼쪽 고정 사이드 메뉴 */}
          <aside className="intro_aside_fixed">
            <div className="intro_aside_header">
              <div className="center_box">
                <span>기업연구동</span>
                <div className="center_line"></div>
              </div>
            </div>
            <ul className="intro_aside_list">
              <li className={`intro_aside_item ${isActive('/inquiryinfo')}`} onClick={() => movePage('/inquiryinfo')}>
                <span>입주안내</span>
                <span className="aside_arrow">&gt;</span>
              </li>
              <li className={`intro_aside_item ${isActive('/floor')}`} onClick={() => movePage('/floor')}>
                <span>층별안내</span>
                <span className="aside_arrow">&gt;</span>
              </li>
              <li className={`intro_aside_item ${isActive('/company')}`} onClick={() => movePage('/company')}>
                <span>입주기업 현황</span>
                <span className="aside_arrow">&gt;</span>
              </li>
              <li
                className={`intro_aside_item ${isActive('/board/inquiry')}`}
                onClick={() => movePage('/board/inquiry')}
              >
                <span>입주문의</span>
                <span className="aside_arrow">&gt;</span>
              </li>
            </ul>
          </aside>

          {/* 오른쪽 내용 영역 */}
          <div className="board_container-sub">
            {/* 제목 + 현재 경로 */}
            <div className="board_path_box">
              <div className="path_title">입주문의 작성</div>
              <div className="path_navi">
                <span className="home_icon_small">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="16" height="16" aria-hidden="true">
                    <path d="M4 11.5L12 4l8 7.5V20a1 1 0 0 1-1 1h-5v-5h-4v5H5a1 1 0 0 1-1-1v-8.5z" fill="#999999" />
                    <path
                      d="M2.5 12L12 3l9.5 9"
                      fill="none"
                      stroke="#cccccc"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </span>
                <span className="path_arrow">&gt;</span>
                <span>기업연구동</span>
                <span className="path_arrow">&gt;</span>
                <span className="current">입주문의 작성</span>
              </div>
            </div>

            {/* 작성 폼 영역 */}
            <div className="list_area">
              <div className="detail_wrap">
                <div className="detail_back">
                  <div className="detail_top_box">
                    <div className="detail_title">
                      <input
                        className="detail_input"
                        placeholder="제목을 입력하세요."
                        type="text"
                        id="title"
                        value={title}
                        onChange={(e) => setTitle(e.target.value)}
                      />
                    </div>
                  </div>

                  <div className="detail_contents_box">
                    <Editor
                      initialValue=" " // content를 Editor의 초기값으로 사용
                      height="300px"
                      initialEditType="wysiwyg"
                      plugins={[colorSyntax]}
                      placeholder="내용을 입력하세요"
                      ref={editorRef}
                      hooks={{
                        addImageBlobHook: onUploadImage,
                      }}
                      onChange={handleContent}
                      id="content"
                    />
                    <br />
                    <div className="detail_top_box">
                      <div className="detail_title">
                        <input
                          className="detail_input"
                          placeholder="이름을 입력하세요."
                          type="text"
                          value={writer}
                          onChange={(e) => setWriter(e.target.value)}
                        />
                      </div>
                    </div>
                    <br />
                    <br />
                    <div className="detail_top_box">
                      <div className="detail_title">
                        <input
                          className="detail_input"
                          placeholder="연락처를 입력하세요."
                          type="text"
                          value={tel}
                          onChange={(e) => setTel(e.target.value)}
                        />
                      </div>
                    </div>
                  </div>

                  <div className="detail_file_box write" style={{ padding: '0px 0', paddingTop: '50px' }}>
                    <div className="file_title">첨부파일 (최대 5개)</div>
                    <div className="file_contents_box">
                      <div className="file_row color" onClick={handleFileClick}>
                        <div className="file_icon"></div>
                        <div className="file_text">사진 및 파일 첨부</div>
                        <input
                          id="file_input"
                          className="file_input"
                          type="file"
                          accept=".jpg, .jpeg, .png, .pdf"
                          onChange={handleFileSelect}
                          multiple
                        />
                      </div>
                      {selectedFiles.map((file, index) => (
                        <div className="file_row ellipsis" key={index}>
                          <div className="file_icon"></div>
                          <div className="file_text ellipsis">{file.name}</div>
                          <div className="delete_btn" onClick={() => handleFileDelete(index)}>
                            X
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>

                  <div className="detail_secret_box">
                    <div className="secret-select">
                      <input
                        type="checkbox"
                        id="secretChk"
                        checked={secretChk}
                        onChange={() => setSecretChk(!secretChk)}
                      />
                      <label htmlFor="secretChk">비밀글</label>
                    </div>
                    {secretChk && (
                      <div className="secret-password-box">
                        <input
                          className="detail_input"
                          placeholder="비밀번호를 입력하세요."
                          type="password"
                          value={password}
                          onChange={(e) => setPassword(e.target.value)}
                        />
                      </div>
                    )}
                  </div>

                  <div className="detail_btn_box">
                    {/* 작성취소 */}
                    <div className="detail_btn cancel" onClick={() => navigate(`/board/${cate}`)}>
                      작성취소
                    </div>

                    {/* 작성완료 */}
                    <div className="detail_btn color" onClick={handleSubmit}>
                      작성완료
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* list_area 끝 */}
          </div>
          {/* board_container-sub 끝 */}
        </div>
        {/* sub_main_area 끝 */}
      </div>
    </div>
  );
};

export default InquiryWrite;
